import React from 'react';
import { TippyTooltip } from '@bbkAdminComponents/tooltips/tippy-tooltip';
import { Icons } from '@bbkAdminUtils/icons';

import './styles/stat.scss';

type Props = {
  /** Label text. If elm then 'bbk-stat-label-inner-element' vertically centers content */
  label?: React.ReactNode;
  /** Is a row? */
  row?: boolean;
  toolTip?: React.ReactNode;
};
export const StatLabel: React.FC<Props> = (props) => {
  const { label, row, toolTip } = props;
  return (
    <span className="stat-label">
      {label}
      {row && ':'}
      {toolTip && (
        <TippyTooltip content={<p className="tw-text-sm">{toolTip}</p>}>
          <span className="tw-ml-1">{Icons.questionMark}</span>
        </TippyTooltip>
      )}
    </span>
  );
};
